const settings = {
  title: "Innstillinger",
  locale: "Språk",
  rows_per_page: "Linjer per side",
  pin_title: "Pin kode",
  change_pin_title: "Endre pin",
  digit_pin: "Tast inn 4 sifret pin",
  pin_not_set: "Pin er ikke satt",
}
export default settings
